<h1 mat-dialog-title>
    <span>{{title}}</span>
    <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{iconname}}</mat-icon>
</h1>
<div mat-dialog-content>
  <div [innerHTML]="message | safeHTML"></div><br /><br />
  <div fxLayout="row" fxLayoutGap="20px">
    <mat-form-field fxFlex>
      <textarea matInput [(ngModel)]="optionalNote" aria-label="Optional note body" placeholder="Enter optional note here..."></textarea>
    </mat-form-field>
  <!-- <j-md-richtext id="NoteTextBox" ng-model="OptionalNote" aria-label="Optional note body"></j-md-richtext> -->    
  </div>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button color="primary" (click)="OKHandler()" [disabled]="!optionalNote">{{oktext}}</button>
  <button mat-raised-button color="warn" (click)="CancelHandler()">{{canceltext}}</button>
</div>
  


// WEBPACK FOOTER //
// ./src/services/dialogs/coursenote/coursenote.dialogcomponent.html